webpackJsonp([1],{

/***/ 1432:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 115,
	"./af.js": 115,
	"./ar": 122,
	"./ar-dz": 116,
	"./ar-dz.js": 116,
	"./ar-kw": 117,
	"./ar-kw.js": 117,
	"./ar-ly": 118,
	"./ar-ly.js": 118,
	"./ar-ma": 119,
	"./ar-ma.js": 119,
	"./ar-sa": 120,
	"./ar-sa.js": 120,
	"./ar-tn": 121,
	"./ar-tn.js": 121,
	"./ar.js": 122,
	"./az": 123,
	"./az.js": 123,
	"./be": 124,
	"./be.js": 124,
	"./bg": 125,
	"./bg.js": 125,
	"./bm": 126,
	"./bm.js": 126,
	"./bn": 127,
	"./bn.js": 127,
	"./bo": 128,
	"./bo.js": 128,
	"./br": 129,
	"./br.js": 129,
	"./bs": 130,
	"./bs.js": 130,
	"./ca": 131,
	"./ca.js": 131,
	"./cs": 132,
	"./cs.js": 132,
	"./cv": 133,
	"./cv.js": 133,
	"./cy": 134,
	"./cy.js": 134,
	"./da": 135,
	"./da.js": 135,
	"./de": 138,
	"./de-at": 136,
	"./de-at.js": 136,
	"./de-ch": 137,
	"./de-ch.js": 137,
	"./de.js": 138,
	"./dv": 139,
	"./dv.js": 139,
	"./el": 140,
	"./el.js": 140,
	"./en-au": 141,
	"./en-au.js": 141,
	"./en-ca": 142,
	"./en-ca.js": 142,
	"./en-gb": 143,
	"./en-gb.js": 143,
	"./en-ie": 144,
	"./en-ie.js": 144,
	"./en-nz": 145,
	"./en-nz.js": 145,
	"./eo": 146,
	"./eo.js": 146,
	"./es": 149,
	"./es-do": 147,
	"./es-do.js": 147,
	"./es-us": 148,
	"./es-us.js": 148,
	"./es.js": 149,
	"./et": 150,
	"./et.js": 150,
	"./eu": 151,
	"./eu.js": 151,
	"./fa": 152,
	"./fa.js": 152,
	"./fi": 153,
	"./fi.js": 153,
	"./fo": 154,
	"./fo.js": 154,
	"./fr": 157,
	"./fr-ca": 155,
	"./fr-ca.js": 155,
	"./fr-ch": 156,
	"./fr-ch.js": 156,
	"./fr.js": 157,
	"./fy": 158,
	"./fy.js": 158,
	"./gd": 159,
	"./gd.js": 159,
	"./gl": 160,
	"./gl.js": 160,
	"./gom-latn": 161,
	"./gom-latn.js": 161,
	"./gu": 162,
	"./gu.js": 162,
	"./he": 163,
	"./he.js": 163,
	"./hi": 164,
	"./hi.js": 164,
	"./hr": 165,
	"./hr.js": 165,
	"./hu": 166,
	"./hu.js": 166,
	"./hy-am": 167,
	"./hy-am.js": 167,
	"./id": 168,
	"./id.js": 168,
	"./is": 169,
	"./is.js": 169,
	"./it": 170,
	"./it.js": 170,
	"./ja": 171,
	"./ja.js": 171,
	"./jv": 172,
	"./jv.js": 172,
	"./ka": 173,
	"./ka.js": 173,
	"./kk": 174,
	"./kk.js": 174,
	"./km": 175,
	"./km.js": 175,
	"./kn": 176,
	"./kn.js": 176,
	"./ko": 177,
	"./ko.js": 177,
	"./ky": 178,
	"./ky.js": 178,
	"./lb": 179,
	"./lb.js": 179,
	"./lo": 180,
	"./lo.js": 180,
	"./lt": 181,
	"./lt.js": 181,
	"./lv": 182,
	"./lv.js": 182,
	"./me": 183,
	"./me.js": 183,
	"./mi": 184,
	"./mi.js": 184,
	"./mk": 185,
	"./mk.js": 185,
	"./ml": 186,
	"./ml.js": 186,
	"./mr": 187,
	"./mr.js": 187,
	"./ms": 189,
	"./ms-my": 188,
	"./ms-my.js": 188,
	"./ms.js": 189,
	"./mt": 190,
	"./mt.js": 190,
	"./my": 191,
	"./my.js": 191,
	"./nb": 192,
	"./nb.js": 192,
	"./ne": 193,
	"./ne.js": 193,
	"./nl": 195,
	"./nl-be": 194,
	"./nl-be.js": 194,
	"./nl.js": 195,
	"./nn": 196,
	"./nn.js": 196,
	"./pa-in": 197,
	"./pa-in.js": 197,
	"./pl": 198,
	"./pl.js": 198,
	"./pt": 200,
	"./pt-br": 199,
	"./pt-br.js": 199,
	"./pt.js": 200,
	"./ro": 201,
	"./ro.js": 201,
	"./ru": 202,
	"./ru.js": 202,
	"./sd": 203,
	"./sd.js": 203,
	"./se": 204,
	"./se.js": 204,
	"./si": 205,
	"./si.js": 205,
	"./sk": 206,
	"./sk.js": 206,
	"./sl": 207,
	"./sl.js": 207,
	"./sq": 208,
	"./sq.js": 208,
	"./sr": 210,
	"./sr-cyrl": 209,
	"./sr-cyrl.js": 209,
	"./sr.js": 210,
	"./ss": 211,
	"./ss.js": 211,
	"./sv": 212,
	"./sv.js": 212,
	"./sw": 213,
	"./sw.js": 213,
	"./ta": 214,
	"./ta.js": 214,
	"./te": 215,
	"./te.js": 215,
	"./tet": 216,
	"./tet.js": 216,
	"./th": 217,
	"./th.js": 217,
	"./tl-ph": 218,
	"./tl-ph.js": 218,
	"./tlh": 219,
	"./tlh.js": 219,
	"./tr": 220,
	"./tr.js": 220,
	"./tzl": 221,
	"./tzl.js": 221,
	"./tzm": 223,
	"./tzm-latn": 222,
	"./tzm-latn.js": 222,
	"./tzm.js": 223,
	"./uk": 224,
	"./uk.js": 224,
	"./ur": 225,
	"./ur.js": 225,
	"./uz": 227,
	"./uz-latn": 226,
	"./uz-latn.js": 226,
	"./uz.js": 227,
	"./vi": 228,
	"./vi.js": 228,
	"./x-pseudo": 229,
	"./x-pseudo.js": 229,
	"./yo": 230,
	"./yo.js": 230,
	"./zh-cn": 231,
	"./zh-cn.js": 231,
	"./zh-hk": 232,
	"./zh-hk.js": 232,
	"./zh-tw": 233,
	"./zh-tw.js": 233
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1432;

/***/ }),

/***/ 1433:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(452)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(1471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1456:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(1467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1457:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(1472),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(1468),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(1477),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)
__webpack_require__(458)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(1476),
  /* scopeId */
  "data-v-aef2b0fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)
__webpack_require__(451)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(1470),
  /* scopeId */
  "data-v-374de35c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)
__webpack_require__(449)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(1469),
  /* scopeId */
  "data-v-20438c26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1463:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)
__webpack_require__(456)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(1475),
  /* scopeId */
  "data-v-7ff12ea6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)
__webpack_require__(445)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(1466),
  /* scopeId */
  "data-v-0151801e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(1474),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1466:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variantType),
      expression: "variantType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.variantType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.variantTypes), function(type, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": type
      }
    }, [_c('span', {
      staticClass: "camel-case"
    }, [_vm._v("\n                    " + _vm._s(type) + "\n                  ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Car),
      expression: "Car"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Car = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.Cars), function(car) {
    return _c('option', {
      key: car._id,
      domProps: {
        "value": car
      }
    }, [_vm._v("\n                  " + _vm._s(car.name) + "\n                ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "camel-case",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v(_vm._s(_vm.variantType) + " Name "), _c('b', [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Color),
      expression: "Color"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.Color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Color = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Price),
      expression: "Price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Enter MSRP"
    },
    domProps: {
      "value": (_vm.Price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Price = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.variantType === 'color') ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/*",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.AddCar()
      }
    }
  }, [_vm._v("\n              Save\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "exampleModal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalCarName),
      expression: "modalCarName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.modalCarName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalCarName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalCarPrice),
      expression: "modalCarPrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Enter MSRP"
    },
    domProps: {
      "value": (_vm.modalCarPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalCarPrice = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.EditCar()
      }
    }
  }, [_vm._v("\n                Edit\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.variantTypes), function(type, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": type
      }
    }, [_c('span', {
      staticClass: "camel-case"
    }, [_vm._v("\n              " + _vm._s(type) + "\n            ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "\n                  display\n                  table table-bordered table-striped\n                  dataTable\n                  wrap\n                ",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "carstable"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "camel-case"
  }, [_vm._v(_vm._s(_vm.filterType))]), _vm._v(" "), (_vm.filterType === 'color') ? _c('th', [_vm._v("Image")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Price")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.variants), function(S, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.car.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.typeSubCategory))]), _vm._v(" "), (_vm.filterType === 'color') ? _c('td', {
      staticClass: "sorting_1"
    }, [_c('img', {
      attrs: {
        "src": S.url,
        "alt": S.typeSubCategory,
        "width": "150"
      },
      on: {
        "click": function($event) {
          _vm.changeImage(S, 'logo' + index)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: 'logo' + index,
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "id": 'logo' + index,
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.changeLogo(S, 'logo' + index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.price))])])
  }))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Add Cars")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Variant Type "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Car "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Price "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Image "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("MSRP "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Filter by Type "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
}]}

/***/ }),

/***/ 1467:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu",
    on: {
      "click": function($event) {
        _vm.Logout()
      }
    }
  }, [_vm._m(1)])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("Log Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])])
}]}

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "id": "searchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "searchContainer"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ }),

/***/ 1469:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maker),
      expression: "maker"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maker = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Maker")]), _vm._v(" "), _vm._l((_vm.Makers), function(maker) {
    return _c('option', {
      key: maker._id,
      domProps: {
        "value": maker._id
      }
    }, [_vm._v("\n                  " + _vm._s(maker.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/*",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.addModelSeries()
      }
    }
  }, [_vm._v("\n              Save\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.Series), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.company.name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-delete",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.deleteModelSeries(S)
        }
      }
    }, [_vm._v("\n                        Delete\n                      ")])])])
  }))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Add Model Series")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Maker "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("File "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Company Name")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),

/***/ 1470:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Subtype),
      expression: "Subtype"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Subtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/*",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.AddMaker()
      }
    }
  }, [_vm._v("\n              Save\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.Makers), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('img', {
      attrs: {
        "src": S.imageUrl,
        "alt": S.name,
        "width": "100",
        "height": "100"
      },
      on: {
        "click": function($event) {
          _vm.changeImage(S, 'logo' + index)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: 'logo' + index,
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "id": 'logo' + index,
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.changeLogo(S, 'logo' + index)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.hasType))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-delete",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.DeleteFile(S)
        }
      }
    }, [_vm._v("\n                        Delete\n                      ")])])])
  }))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Add Maker")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Has Subtype "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("File "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("Has Type")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),

/***/ 1471:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Oops,")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1472:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 item-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 item-right"
  }, [(_vm.showLogin) ? _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    attrs: {
      "id": "Logo"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Login")]), _vm._v(" "), _c('p', [_vm._v("Please enter your email and password to login")]), _vm._v(" "), (_vm.ErrorMessage == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n          Please enter the fields marked *\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Enter Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "id": "LoginButton"
    },
    on: {
      "click": function($event) {
        _vm.UserLogin()
      }
    }
  }, [_vm._v("\n          Login\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.LoginError == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n            Sorry, please check the above details and try again\n          ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.showLogin) ? _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    attrs: {
      "id": "Logo"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Sign up")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.name),
      expression: "userModel.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputEmail",
      "placeholder": "Enter Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.email),
      expression: "userModel.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Enter Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.mobile),
      expression: "userModel.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputEmail",
      "placeholder": "Enter Mobile",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userModel.password),
      expression: "userModel.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.userModel.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userModel, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "id": "LoginButton"
    },
    on: {
      "click": function($event) {
        _vm.UserSignUp()
      }
    }
  }, [_vm._v("\n          Sign up\n        ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.LoginError == true) ? _c('h5', {
    staticClass: "error"
  }, [_vm._v("\n            Sorry, please check the above details and try again\n          ")]) : _vm._e()])], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 1473:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1474:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Cars))]), _vm._v(" "), _c('p', [_vm._v("Total Cars")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Makers))]), _vm._v(" "), _c('p', [_vm._v("Total Makers")])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Types))]), _vm._v(" "), _c('p', [_vm._v("Total Types")])]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-bag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-bag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-bag"
  })])
}]}

/***/ }),

/***/ 1475:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maker),
      expression: "maker"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maker = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.Makers), function(maker) {
    return _c('option', {
      key: maker._id,
      domProps: {
        "value": maker._id
      }
    }, [_vm._v(_vm._s(maker.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.addType()
      }
    }
  }, [_vm._v("\n              Save\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.Types), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.company.name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-delete",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.DeleteType(S)
        }
      }
    }, [_vm._v("\n                        Delete\n                      ")])])])
  }))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Add Types")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Maker "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Company Name")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),

/***/ 1476:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msrp),
      expression: "msrp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Enter MSRP"
    },
    domProps: {
      "value": (_vm.msrp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msrp = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maker),
      expression: "maker"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maker = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.Makers), function(maker) {
    return _c('option', {
      key: maker._id,
      domProps: {
        "value": maker
      }
    }, [_vm._v("\n                  " + _vm._s(maker.name) + "\n                ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Model Series")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modelSeries),
      expression: "modelSeries"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.modelSeries = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": {}
    }
  }, [_vm._v("Select Model Series")]), _vm._v(" "), _vm._l((_vm.filteredSeries), function(series) {
    return _c('option', {
      key: series._id,
      domProps: {
        "value": series
      }
    }, [_vm._v("\n                  " + _vm._s(series.name) + "\n                ")])
  })], 2)]), _vm._v(" "), (_vm.hasType) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    attrs: {
      "required": _vm.hasType
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.Types), function(t) {
    return _c('option', {
      key: t._id,
      domProps: {
        "value": t._id
      }
    }, [_vm._v("\n                  " + _vm._s(t.name) + "\n                ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/*",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_vm._m(6), _vm._v(" "), _c('VueEditor', {
    model: {
      value: (_vm.Description),
      callback: function($$v) {
        _vm.Description = $$v
      },
      expression: "Description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.AddCar()
      }
    }
  }, [_vm._v("\n              Save\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "exampleModal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body test col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalCarName),
      expression: "modalCarName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter Name"
    },
    domProps: {
      "value": (_vm.modalCarName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalCarName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalCarPrice),
      expression: "modalCarPrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": "Enter MSRP"
    },
    domProps: {
      "value": (_vm.modalCarPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalCarPrice = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_vm._m(10), _vm._v(" "), _c('VueEditor', {
    model: {
      value: (_vm.modalCarDescription),
      callback: function($$v) {
        _vm.modalCarDescription = $$v
      },
      expression: "modalCarDescription"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Model Series")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modelSeriesIdEdit),
      expression: "modelSeriesIdEdit"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.modelSeriesIdEdit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Model Series")]), _vm._v(" "), _vm._l((_vm.filteredEditSeries), function(series) {
    return _c('option', {
      key: series._id,
      domProps: {
        "value": series._id
      }
    }, [_vm._v("\n                    " + _vm._s(series.name) + "\n                  ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer test"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.EditCar()
      }
    }
  }, [_vm._v("\n                Edit\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "carstable"
    }
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((_vm.Cars), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('img', {
      attrs: {
        "src": S.imageUrl,
        "alt": S.name,
        "width": "150"
      },
      on: {
        "click": function($event) {
          _vm.changeImage(S, 'logo' + index)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: 'logo' + index,
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "id": 'logo' + index,
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.changeLogo(S, 'logo' + index)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.price))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.company.name))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-delete",
      attrs: {
        "type": "submit",
        "data-toggle": "modal",
        "data-target": "#exampleModal"
      },
      on: {
        "click": function($event) {
          _vm.openModal(S)
        }
      }
    }, [_vm._v("\n                        Edit\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-outline-delete",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.DeleteFile(S)
        }
      }
    }, [_vm._v("\n                        Delete\n                      ")])])])
  }))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Add Cars")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("MSRP "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Maker "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Type "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("File "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Description "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Modal title")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("MSRP "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Description "), _c('b', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Image")]), _vm._v(" "), _c('th', [_vm._v("MSRP")]), _vm._v(" "), _c('th', [_vm._v("Company")]), _vm._v(" "), _c('th')])])
}]}

/***/ }),

/***/ 1477:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/makers"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Makers")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/series"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Model Series")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/types"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Types")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cars"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cars")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/variants"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Variants")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1480:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1481:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1482:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1483:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalStore", function() { return globalStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_App_vue__);















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("count", __WEBPACK_IMPORTED_MODULE_7__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("domain", __WEBPACK_IMPORTED_MODULE_7__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("prettyDate", __WEBPACK_IMPORTED_MODULE_7__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("pluralize", __WEBPACK_IMPORTED_MODULE_7__filters__["d" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("formatDate", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format("DD-MMM-YYYY | HH:mm");
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("Birthdate", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format("DD-MMM-YYYY");
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_5__routes__["a" /* default */],
  mode: "history",
  linkExactActiveClass: "active",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === "null")) {
    window.console.log("Not authenticated");
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem("user") || "null";
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit("SET_USER", localUser);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit("SET_TOKEN", window.localStorage.getItem("token"));
  }
}

var globalStore = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  data: {
    url: "https://notsticker-backend-1f08ac3d5994.herokuapp.com/",

    UserId: "",

    AdminId: localStorage.getItem("AdminId"),

    TemplateId: "5c015794a6daf7682493cc3c"

  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: "#root",
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__components_App_vue___default.a);
  }
});

window.bugsnagClient = window.bugsnag("02fe1c2caaf5874c50b6ee19534f5932");
window.bugsnagClient.use(window.bugsnag__vue(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]));

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_AddMakers_vue__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_AddMakers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_AddMakers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_AddTypes_vue__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_AddTypes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_AddTypes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_AddCars_vue__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_AddCars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_AddCars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_AddVariants_vue__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_AddVariants_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_AddVariants_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_AddModelSeries_vue__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_AddModelSeries_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_AddModelSeries_vue__);












var routes = [{
  path: "/login",
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: "/",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: "dashboard",
    alias: "",
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default.a,
    name: "Dashboard",
    meta: { description: "" }
  }, {
    path: "makers",
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_AddMakers_vue___default.a,
    name: "All Makers",
    meta: { description: "" }
  }, {
    path: "cars",
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_AddCars_vue___default.a,
    name: "All Cars",
    meta: { description: "" }
  }, {
    path: "variants",
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_AddVariants_vue___default.a,
    name: "All Variants",
    meta: { description: "" }
  }, {
    path: "types",
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_AddTypes_vue___default.a,
    name: "All Types",
    meta: { description: "" }
  }, {
    path: "series",
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_AddModelSeries_vue___default.a,
    name: "All Model Series",
    meta: { description: "" }
  }]
}, {
  path: "*",
  component: __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(297);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(1473),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }

      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faker__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_faker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_faker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hideseek__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__Sidebar___default.a
  },
  data: function data() {
    return {
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
      },
      error: ''
    };
  },
  mounted: function mounted() {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['userInfo']), {
    demo: function demo() {
      return {
        displayName: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.name.findName(),
        avatar: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.image.avatar(),
        email: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.internet.email(),
        randomCard: __WEBPACK_IMPORTED_MODULE_1_faker___default.a.helpers.createCard()
      };
    }
  }),
  methods: {
    CheckLogin: function CheckLogin() {
      if (localStorage.getItem('user')) {
        console.log(localStorage.getItem('user'));
      } else {
        console.log("admin object not set");
        this.$router.push('/login');
      }
    },
    Logout: function Logout() {
      console.log("Log Out Clicked");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.$router.push('/login');
      location.reload();
    },
    GetFeedbacks: function GetFeedbacks() {
      console.log("Get All Feedbacks API Called...");
    }
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Login",
  data: function data(router) {
    return {
      username: "",
      password: "",
      ErrorMessage: false,
      LoginError: false,
      showLogin: true,
      userModel: {
        name: "",
        mobile: "",
        email: "",
        password: ""
      }
    };
  },

  methods: {
    SignUp: function SignUp() {
      this.showLogin = false;
    },
    UserSignUp: function UserSignUp() {
      var _this = this;

      console.log("model", this.userModel);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].url + "api/add-user", this.userModel).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
          icon: "success",
          title: "Your account has been created successfully",
          showConfirmButton: false,
          timer: 1500
        });
        _this.showLogin = true;
      }).catch(function (e) {
        console.log("err creating acc", e);
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
      });
    },
    UserLogin: function UserLogin() {
      var _this2 = this;

      console.log("user login");


      if (this.username != "" && this.password != "") {
        console.log(this.username);
        console.log(this.password);

        console.log("URL: " + __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].url);
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].url + "auth/admin-login", {
          email: this.username,
          password: this.password
        }).then(function (res) {
          console.log(res);
          var token = {
            headers: {
              authtoken: res.data.data.token
            }
          };
          localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.data));
          localStorage.setItem("token", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(token));
          _this2.$router.push("/");
        }).catch(function (e) {
          console.log("error is :" + e);
          _this2.LoginError = true;
          _this2.ErrorMessage = false;
        });
      } else {
        this.ErrorMessage = true;
      }
    }
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  },
  methods: {}
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SidebarMenu",
  mounted: function mounted() {
    this.CheckLogin();
  },

  methods: {
    CheckLogin: function CheckLogin() {
      if (localStorage.getItem("user")) {
        console.log(localStorage.getItem("user"));
      } else {
        console.log("admin object not set");
        this.$router.push("/login");
      }
    }
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main_js__ = __webpack_require__(18);













__webpack_require__(23);
__webpack_require__(39);

var aesjs = __webpack_require__(27);
var eccrypto = __webpack_require__(40);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    VueEditor: __WEBPACK_IMPORTED_MODULE_7_vue2_editor__["a" /* VueEditor */]
  },
  data: function data() {
    return {
      Name: "",
      Description: "",
      Cars: [],
      Makers: [],
      Series: [],
      Types: [],
      token: JSON.parse(localStorage.getItem("token")),
      hasType: false,
      maker: {},
      modelSeries: {},
      type: "",
      msrp: "",
      modalCarName: "",
      modalCarDescription: "",
      modelSeriesIdEdit: "",
      filteredEditSeries: [],
      modalCarPrice: "",
      modalCarId: ""
    };
  },
  mounted: function mounted() {
    this.getAllCars();
    this.getAllMakers();
    this.getAllModelSeries();
  },

  computed: {
    filteredSeries: function filteredSeries() {
      var _this = this;

      if (!this.maker._id) {
        this.Series;
      }
      return this.Series.filter(function (s) {
        return s.company._id === _this.maker._id;
      });
    }
  },
  watch: {
    maker: function maker(val) {
      console.log("val", val);
      this.hasType = val.hasType;
      if (this.hasType) {
        this.getTypesForMaker(val._id);
      }
      console.log("hasType", this.hasType);
    }
  },
  methods: {
    openModal: function openModal(car) {
      this.modalCarId = car._id;
      this.modalCarName = car.name;
      this.modalCarPrice = car.price;
      this.modalCarDescription = car.description;
      this.modelSeriesIdEdit = car.modelSeries._id;
      this.filteredEditSeries = this.Series.filter(function (s) {
        return s.company._id === car.company._id;
      });
    },
    EditCar: function EditCar() {
      var data = {
        carId: this.modalCarId,
        name: this.modalCarName,
        price: this.modalCarPrice,
        description: this.modalCarDescription
      };
      if (this.modelSeriesIdEdit) {
        data.modelSeries = this.modelSeriesIdEdit;
      }
      console.log("data: ", data);

      if (this.modalCarPrice === "" || this.modalCarId === "" || this.modalCarName === "") {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Enter all values and try again", "error");
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "product/update-car", data, this.token).then(function (res) {
        console.log("saved success", res);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          icon: "success",
          title: "Your Car has been saved",
          showConfirmButton: false,
          timer: 1500
        });
        setTimeout(function () {
          location.reload();
        }, 1000);
      }).catch(function (e) {
        console.log("error saving file", e);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
      });
    },
    handleFileUpload: function handleFileUpload() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.file = _this2.$refs.file.files[0];
                _this2.fileType = _this2.file.type;
                _this2.fileName = _this2.file.name;
                console.log("this.file", _this2.file);
                console.log("this.file", _this2.fileType);
                console.log("this.file", _this2.fileName);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    AddCar: function AddCar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData, headers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                formData.append("name", _this3.Name);
                formData.append("company", _this3.maker._id);
                formData.append("price", _this3.msrp);
                formData.append("description", _this3.Description);
                formData.append("photo", _this3.$refs.file.files[0]);
                if (_this3.modelSeries._id) {
                  formData.append("modelSeries", _this3.modelSeries._id);
                }
                if (_this3.hasType) {
                  formData.append("cartype", _this3.type);
                }
                console.log("formData", formData);
                headers = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    authtoken: _this3.token.headers.authtoken
                  }
                };

                console.log(headers);

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "product/createCar", formData, headers).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Your Car has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this3.Name = "";
                  _this3.file = "";
                  _this3.msrp = "";
                  _this3.type = "";
                  _this3.Description = "";
                  _this3.modelSeries = {};
                  _this3.getAllCars();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getAllMakers: function getAllMakers() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "product/getCompanies", this.token).then(function (res) {
        console.log("all Makers", res.data.data);
        _this4.Makers = res.data.data;
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    getTypesForMaker: function getTypesForMaker(makerId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "product/getCarTypeByCompany/" + makerId, _this5.token).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            console.log("all Makers", res.data.data);
                            _context3.next = 3;
                            return res.data.data;

                          case 3:
                            _this5.Types = _context3.sent;

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this5);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (e) {
                  console.log("error getting all files", e);
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    getAllCars: function getAllCars() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "product/getAllCars", this.token).then(function (res) {
        console.log("all Makers", res.data.data);
        setTimeout(function () {
          _this6.DisplayTable();
        }, 150);
        _this6.Cars = res.data.data;
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    getAllModelSeries: function getAllModelSeries() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "series/getSeries", this.token).then(function (res) {
        _this7.Series = res.data.data;
        console.log("all model series", _this7.Series);
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    DeleteFile: function DeleteFile(car) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(function (result) {
        if (result.value) {
          var data = {
            carId: car._id
          };
          console.log(data);
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "product/delete-car", data, _this8.token).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
              icon: "success",
              title: "car is deleted",
              showConfirmButton: false,
              timer: 1500
            });
            _this8.getAllCars();
          }).catch(function (e) {
            console.log("error deleteing", e);
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
          });
        }
      });
    },
    changeLogo: function changeLogo(car, id) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var carId, file, formData, headers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                carId = car._id;
                file = _this9.$refs[id][0].files[0];

                if (!(!carId || !file)) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                console.log(carId);
                console.log(_this9.$refs);
                console.log(_this9.$refs[id][0].files[0]);
                formData = new FormData();

                formData.append("carId", carId);
                formData.append("photo", file);
                console.log("formData", formData);
                headers = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    authtoken: _this9.token.headers.authtoken
                  }
                };

                console.log(headers);

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_8__main_js__["globalStore"].url + "product/car-logo-update", formData, headers).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Your image has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this9.getAllCars();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });
                return _context5.abrupt("return");

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    changeImage: function changeImage(maker, id) {
      document.getElementById(id).click();
    },
    DisplayTable: function DisplayTable() {
      var _this10 = this;

      setTimeout(function () {
        _this10.$nextTick(function () {
          var table = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#carstable").DataTable({
            dom: "Blftip",
            orderCellsTop: true,
            fixedHeader: true,
            fixedColumns: true,
            autoWidth: false,
            buttons: [{
              extend: "csvHtml5",
              text: "Export To Excel",
              title: "All Feedback"
            }]
          });

          __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#example thead tr").clone(true).appendTo("#example thead");
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#example thead tr:eq(1) th").each(function (i) {
            var title = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).text();
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).html('<input type="text" placeholder="Search ' + title + '" />');

            __WEBPACK_IMPORTED_MODULE_2_jquery___default()("input", this).on("keyup change", function () {
              if (table.column(i).search() !== this.value) {
                table.column(i).search(this.value).draw();
              }
            });
          });
        });
      }, 100);
    }
  }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_js__ = __webpack_require__(18);












__webpack_require__(23);
__webpack_require__(39);

var aesjs = __webpack_require__(27);
var eccrypto = __webpack_require__(40);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  data: function data() {
    return {
      Name: "",
      Subtype: "no",
      file: "",
      fileType: "",
      fileName: "",
      Makers: [],
      token: JSON.parse(localStorage.getItem("token"))
    };
  },
  mounted: function mounted() {
    this.getAllMakers();
  },

  computed: {},
  methods: {
    handleFileUpload: function handleFileUpload() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.file = _this.$refs.file.files[0];
                _this.fileType = _this.file.type;
                _this.fileName = _this.file.name;
                console.log("this.file", _this.file);
                console.log("this.file", _this.fileType);
                console.log("this.file", _this.fileName);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    AddMaker: function AddMaker() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData, headers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                formData.append("name", _this2.Name);
                formData.append("hasType", _this2.Subtype);
                formData.append("photo", _this2.$refs.file.files[0]);

                console.log("formData", formData);
                headers = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    authtoken: _this2.token.headers.authtoken
                  }
                };

                console.log(headers);

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/createCompany", formData, headers).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Your File has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this2.Name = "";
                  _this2.file = "";
                  _this2.getAllMakers();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getAllMakers: function getAllMakers() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/getCompanies", this.token).then(function (res) {
        console.log("all Makers", res.data.data);
        _this3.Makers = res.data.data;
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    DeleteFile: function DeleteFile(maker) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(function (result) {
        if (result.value) {
          var data = {
            makerId: maker._id
          };
          console.log(data);
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/delete-maker", data, _this4.token).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
              icon: "success",
              title: "Maker is deleted",
              showConfirmButton: false,
              timer: 1500
            });
            _this4.getAllMakers();
          }).catch(function (e) {
            console.log("error deleteing", e);
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
          });
        }
      });
    },
    changeLogo: function changeLogo(maker, id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var makerId, file, formData, headers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                makerId = maker._id;
                file = _this5.$refs[id][0].files[0];

                if (!(!makerId || !file)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                console.log(makerId);
                console.log(_this5.$refs);
                console.log(_this5.$refs[id][0].files[0]);
                formData = new FormData();

                formData.append("makerId", makerId);
                formData.append("photo", file);
                console.log("formData", formData);
                headers = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    authtoken: _this5.token.headers.authtoken
                  }
                };

                console.log(headers);

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/maker-logo-update", formData, headers).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Your image has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this5.getAllMakers();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });
                return _context3.abrupt("return");

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    changeImage: function changeImage(maker, id) {
      document.getElementById(id).click();
    }
  }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_js__ = __webpack_require__(18);













__webpack_require__(23);
__webpack_require__(39);

var aesjs = __webpack_require__(27);
var eccrypto = __webpack_require__(40);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  data: function data() {
    return {
      Name: "",

      maker: "",
      Makers: [],
      Series: [],
      token: JSON.parse(localStorage.getItem("token"))
    };
  },
  mounted: function mounted() {
    this.getAllMakers();
    this.getAllModelSeries();
  },

  computed: {},
  methods: {
    handleFileUpload: function handleFileUpload() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.file = _this.$refs.file.files[0];
                _this.fileType = _this.file.type;
                _this.fileName = _this.file.name;
                console.log("this.file", _this.file);
                console.log("this.file", _this.fileType);
                console.log("this.file", _this.fileName);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addModelSeries: function addModelSeries() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var request, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                request = {
                  name: _this2.Name,
                  company: _this2.maker,
                  photo: _this2.$refs.file.files[0],
                  description: _this2.Description
                };
                formData = new FormData();

                formData.append("name", _this2.Name);
                formData.append("company", _this2.maker);
                formData.append("photo", _this2.$refs.file.files[0]);

                console.log("req", request);
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "series/createSeries", formData, _this2.token).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Car Type Created",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this2.Name = "";
                  _this2.file = "";
                  _this2.getAllModelSeries();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getAllMakers: function getAllMakers() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/getCompanies", this.token).then(function (res) {
        _this3.Makers = res.data.data;
        console.log("all Makers with type", _this3.Makers);
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    getAllModelSeries: function getAllModelSeries() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "series/getSeries", this.token).then(function (res) {
        _this4.Series = res.data.data;
        console.log("all model series", _this4.Series);
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    deleteModelSeries: function deleteModelSeries(series) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(function (result) {
        if (result.value) {
          var data = {
            seriesId: series._id
          };
          console.log(data);
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "series/delete-series", data, _this5.token).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
              icon: "success",
              title: "Maker is deleted",
              showConfirmButton: false,
              timer: 1500
            });
            _this5.getAllModelSeries();
          }).catch(function (e) {
            console.log("error deleteing", e);
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_js__ = __webpack_require__(18);












__webpack_require__(23);
__webpack_require__(39);

var aesjs = __webpack_require__(27);
var eccrypto = __webpack_require__(40);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  data: function data() {
    return {
      Name: "",
      Makers: [],
      Types: [],
      maker: '',
      token: JSON.parse(localStorage.getItem("token"))
    };
  },
  mounted: function mounted() {
    this.getAllMakers();
    this.getAllCarTypes();
  },

  computed: {},
  methods: {
    handleFileUpload: function handleFileUpload() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.file = _this.$refs.file.files[0];
                _this.fileType = _this.file.type;
                _this.fileName = _this.file.name;
                console.log("this.file", _this.file);
                console.log("this.file", _this.fileType);
                console.log("this.file", _this.fileName);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    addType: function addType() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var request;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                request = {
                  name: _this2.Name,
                  company: _this2.maker
                };

                console.log("req", request);
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/createCarType", request, _this2.token).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Car Type Created",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this2.Name = "";
                  _this2.file = "";
                  _this2.getAllCarTypes();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getAllMakers: function getAllMakers() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/getCompanies", this.token).then(function (res) {
        _this3.Makers = res.data.data.filter(function (x) {
          return x.hasType === true;
        });
        console.log("all Makers with type", _this3.Makers);
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    getAllCarTypes: function getAllCarTypes() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/getCarTypes", this.token).then(function (res) {
        _this4.Types = res.data.data;
        console.log("all Types", _this4.Types);
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    DeleteType: function DeleteType(type) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(function (result) {
        if (result.value) {
          var data = {
            typeId: type._id
          };
          console.log(data);
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/delete-car-type", data, _this5.token).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
              icon: "success",
              title: "Maker is deleted",
              showConfirmButton: false,
              timer: 1500
            });
            _this5.getAllCarTypes();
          }).catch(function (e) {
            console.log("error deleteing", e);
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
          });
        }
      });
    },
    changeLogo: function changeLogo(maker, id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var makerId, file, formData, headers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                makerId = maker._id;
                file = _this6.$refs[id][0].files[0];

                if (!(!makerId || !file)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                console.log(makerId);
                console.log(_this6.$refs);
                console.log(_this6.$refs[id][0].files[0]);
                formData = new FormData();

                formData.append("makerId", makerId);
                formData.append("photo", file);
                console.log("formData", formData);
                headers = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    authtoken: _this6.token.headers.authtoken
                  }
                };

                console.log(headers);

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/maker-logo-update", formData, headers).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Your image has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this6.getAllMakers();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });
                return _context3.abrupt("return");

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    changeImage: function changeImage(maker, id) {
      document.getElementById(id).click();
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_js__ = __webpack_require__(18);












__webpack_require__(23);
__webpack_require__(39);

var aesjs = __webpack_require__(27);
var eccrypto = __webpack_require__(40);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  data: function data() {
    return {
      Name: "",
      Color: "",
      Price: "",
      Car: {},
      Cars: [],
      variants: [],
      maker: {},
      token: JSON.parse(localStorage.getItem("token")),
      hasType: false,
      type: "",
      msrp: "",
      Types: [],
      modalCarName: "",
      modalCarPrice: "",
      modalCarId: "",
      variantType: "color",
      filterType: "color",
      variantTypes: ["color", "options"],
      dataTable: undefined
    };
  },
  mounted: function mounted() {
    this.getAllCars();
    this.getAllCarVariants();
  },

  watch: {
    maker: function maker(val) {
      console.log("val", val);
      this.hasType = val.hasType;
      if (this.hasType) {
        this.getTypesForMaker(val._id);
      }
      console.log("hasType", this.hasType);
    },
    filterType: function filterType(val) {
      this.getAllCarVariants(val);
    }
  },
  methods: {
    openModal: function openModal(car) {
      this.modalCarId = car._id;
      this.modalCarName = car.name;
      this.modalCarPrice = car.price;
    },
    EditCar: function EditCar() {
      var data = {
        carId: this.modalCarId,
        name: this.modalCarName,
        price: this.modalCarPrice
      };
      console.log("data", data);
      if (this.modalCarPrice === "" || this.modalCarId === "" || this.modalCarName === "") {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Enter all values and try again", "error");
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/update-car", data, this.token).then(function (res) {
        console.log("saved success", res);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
          icon: "success",
          title: "Your Car has been saved",
          showConfirmButton: false,
          timer: 1500
        });
        setTimeout(function () {
          location.reload();
        }, 1000);
      }).catch(function (e) {
        console.log("error saving file", e);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
      });
    },
    handleFileUpload: function handleFileUpload() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.file = _this.$refs.file.files[0];
                _this.fileType = _this.file.type;
                _this.fileName = _this.file.name;
                console.log("this.file", _this.file);
                console.log("this.file", _this.fileType);
                console.log("this.file", _this.fileName);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    AddCar: function AddCar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData, headers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                formData.append("car", _this2.Car._id);
                formData.append("typeCategory", _this2.variantType);
                formData.append("typeSubCategory", _this2.Color);
                formData.append("price", _this2.Price);
                if (_this2.variantType === "color") {
                  formData.append("photo", _this2.$refs.file.files[0]);
                }
                console.log("formData", formData);
                headers = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    authtoken: _this2.token.headers.authtoken
                  }
                };

                console.log(headers);

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/createCarVariant", formData, headers).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Your Car Variant has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  location.reload();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getAllCarVariants: function getAllCarVariants(variantType) {
      var _this3 = this;

      var query = "";
      if (variantType && variantType.trim()) {
        query = "product/getAllCarVariants?variantType=" + variantType;
      }
      query = "product/getAllCarVariants?variantType=" + this.filterType;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + ("" + query), this.token).then(function (res) {
        console.log("all variants", res.data.data);
        _this3.variants = res.data.data;
        setTimeout(function () {
          _this3.DisplayTable();
        }, 150);
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    getTypesForMaker: function getTypesForMaker(makerId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/getCarTypeByCompany/" + makerId, _this4.token).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            console.log("all Makers", res.data.data);
                            _context3.next = 3;
                            return res.data.data;

                          case 3:
                            _this4.Types = _context3.sent;

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (e) {
                  console.log("error getting all files", e);
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getAllCars: function getAllCars() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/getAllCars", this.token).then(function (res) {
        console.log("all cars", res.data.data);
        setTimeout(function () {
          _this5.DisplayTable();
        }, 150);
        _this5.Cars = res.data.data;
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    DeleteFile: function DeleteFile(car) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(function (result) {
        if (result.value) {
          var data = {
            carId: car._id
          };
          console.log(data);
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/delete-car", data, _this6.token).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
              icon: "success",
              title: "car is deleted",
              showConfirmButton: false,
              timer: 1500
            });
            _this6.getAllCars();
          }).catch(function (e) {
            console.log("error deleteing", e);
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
          });
        }
      });
    },
    changeLogo: function changeLogo(car, id) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var carId, file, formData, headers;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                carId = car._id;
                file = _this7.$refs[id][0].files[0];

                if (!(!carId || !file)) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                console.log(carId);
                console.log(_this7.$refs);
                console.log(_this7.$refs[id][0].files[0]);
                formData = new FormData();

                formData.append("carVariantId", carId);
                formData.append("photo", file);
                console.log("formData", formData);
                headers = {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    authtoken: _this7.token.headers.authtoken
                  }
                };

                console.log(headers);

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7__main_js__["globalStore"].url + "product/variant-photo-update", formData, headers).then(function (res) {
                  console.log("saved success", res);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    icon: "success",
                    title: "Your image has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  _this7.getAllCarVariants();
                }).catch(function (e) {
                  console.log("error saving file", e);
                  __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Oops...", "Something went wrong!", "error");
                });
                return _context5.abrupt("return");

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    changeImage: function changeImage(maker, id) {
      document.getElementById(id).click();
    },
    DisplayTable: function DisplayTable() {
      var _this8 = this;

      setTimeout(function () {
        _this8.$nextTick(function () {
          _this8.dataTable = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#carstable").DataTable({
            dom: "Blftip",
            orderCellsTop: true,
            fixedHeader: true,
            fixedColumns: true,
            autoWidth: false,
            buttons: [{
              extend: "csvHtml5",
              text: "Export To Excel",
              title: "All Feedback"
            }]
          });

          __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#example thead tr").clone(true).appendTo("#example thead");
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#example thead tr:eq(1) th").each(function (i) {
            var title = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).text();
            __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).html('<input type="text" placeholder="Search ' + title + '" />');

            __WEBPACK_IMPORTED_MODULE_2_jquery___default()("input", this).on("keyup change", function () {
              if (table.column(i).search() !== this.value) {
                table.column(i).search(this.value).draw();
              }
            });
          });
        });
      }, 100);
    }
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_js__ = __webpack_require__(18);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      FilesCount: 0,
      token: JSON.parse(localStorage.getItem("token")),
      Cars: 0,
      Types: 0,
      Makers: 0
    };
  },
  mounted: function mounted() {
    this.getAllCars();
    this.getAllMakers();
    this.getAllCarTypes();
  },

  methods: {
    getAllCars: function getAllCars() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__main_js__["globalStore"].url + 'product/getAllCars', this.token).then(function (res) {
        console.log("all Makers", res.data.data);
        _this.Cars = res.data.data.length;
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    getAllMakers: function getAllMakers() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__main_js__["globalStore"].url + 'product/getCompanies', this.token).then(function (res) {
        console.log("all Makers", res.data.data);
        _this2.Makers = res.data.data.length;
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    },
    getAllCarTypes: function getAllCarTypes() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__main_js__["globalStore"].url + 'product/getCarTypes', this.token).then(function (res) {
        _this3.Types = res.data.data.length;
      }).catch(function (e) {
        console.log("error getting all files", e);
      });
    }
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(88);



/* unused harmony default export */ var _unused_webpack_default_export = ({
  request: function request(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!method) {
      console.error('API function call requires method argument');
      return;
    }

    if (!uri) {
      console.error('API function call requires uri argument');
      return;
    }

    var url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + uri;
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({ method: method, url: url, data: data });
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  }
});

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.5.1","/Users/kapilupadhyay/Desktop/drivlo/drivlo-admin"]],"_from":"elliptic@6.5.1","_id":"elliptic@6.5.1","_inBundle":false,"_integrity":"sha512-xvJINNLbTeWQjrl6X+7eQCrIy/YPv5XCpKW6kB5mKvtnGILoLDcySuwomfdzt0BMdLNVnuRNTuzKNHj0bva1Cg==","_location":"/eccrypto/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.1","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.1","saveSpec":null,"fetchSpec":"6.5.1"},"_requiredBy":["/eccrypto"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.1.tgz","_spec":"6.5.1","_where":"/Users/kapilupadhyay/Desktop/drivlo/drivlo-admin","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.4","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.6.0","mocha":"^6.1.4"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.1"}

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/Users/kapilupadhyay/Desktop/drivlo/drivlo-admin"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/Users/kapilupadhyay/Desktop/drivlo/drivlo-admin","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ })

},[18]);


// WEBPACK FOOTER //
// static/js/app.6ffa1a34956cc21d5910.js